<template>
  <main class="rh-home">
    <header class="hero">
      <p class="eyebrow">RH</p>
      <h1>Home de Recrutamento e Seleção</h1>
      <p class="description">
        Escolha a ação desejada para este módulo.
      </p>
    </header>

    <section class="grid">
      <article class="card">
        <h2>Processos seletivos</h2>
        <p>Acompanhe os processos já criados e suas entrevistas.</p>
        <router-link class="card-link" :to="`/${company}/eia/recrutamento/processos`">
          Abrir processos
        </router-link>
      </article>

      <article class="card">
        <h2>Novo processo</h2>
        <p>Cadastre e publique um novo processo seletivo.</p>
        <router-link class="card-link" :to="`/${company}/eia/recrutamento/form-pesquisa`">
          Criar processo
        </router-link>
      </article>

      <article class="card">
        <h2>Indicadores</h2>
        <p>Visualize indicadores do módulo de recrutamento.</p>
        <router-link class="card-link" :to="`/${company}/eia/recrutamento/indicadores`">
          Ver indicadores
        </router-link>
      </article>
    </section>

    <footer class="actions">
      <router-link class="link" :to="`/${company}`">Voltar para home da empresa</router-link>
      <router-link class="link" :to="`/${company}/grc`">Ir para GRC</router-link>
    </footer>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const normalizeSlug = (value) => (value || '')
  .toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

const company = computed(() => normalizeSlug(route.params.company) || 'due');
</script>

<style scoped>
.rh-home {
  max-width: 1024px;
  margin: 0 auto;
  padding: 32px 20px 48px;
  color: #0f172a;
}

.hero {
  margin-bottom: 24px;
}

.eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0369a1;
}

h1 {
  margin: 0 0 8px;
  font-size: 32px;
  line-height: 1.2;
}

.description {
  margin: 0;
  font-size: 16px;
  color: #334155;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-bottom: 28px;
}

.card {
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 16px;
  background: #f8fafc;
}

.card h2 {
  margin: 0 0 8px;
  font-size: 18px;
}

.card p {
  margin: 0 0 12px;
  color: #334155;
}

.card-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0f172a;
  border-radius: 8px;
  padding: 8px 12px;
  text-decoration: none;
  color: #0f172a;
  font-weight: 600;
  background: #ffffff;
}

.card-link:hover {
  background: #f1f5f9;
}

.actions {
  display: flex;
  gap: 12px;
}

.link {
  color: #0369a1;
  font-weight: 600;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}
</style>
